// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ed-0";
export var fileCarousel = "_ed-2";
export var removeFileButton = "_ed-1";